import type { DataNodeDetail } from 'api/project-nodes/types';

import type { CandidateRelationView, GraphNodeView } from './types';
import type { TemplateMaps } from './useTemplateMaps';
import { candidateRelations } from './utils/candidateRelations';
import { toGraphNodeView } from './utils/mapConnectedNode';

/**
 * Resolve the graph root (a `DataNodeDetail`) into a display `GraphNodeView` using the blueprint. The
 * node's `templateNodeId` is supplied by the caller (it launched the graph from a known type), not read
 * off the DTO.
 */
export function buildGraphNodeView(detail: DataNodeDetail, templateNodeId: string, maps: TemplateMaps): GraphNodeView {
  const type = maps.nodeMap[templateNodeId];
  return toGraphNodeView(detail, {
    templateNodeId,
    technicalName: type?.technicalName ?? '',
    icon: type?.icon || 'Node'
  });
}

/** The candidate relations a node type can expand to — blueprint-derived, resolved for display. */
export function buildCandidateRelations(templateNodeId: string, maps: TemplateMaps): CandidateRelationView[] {
  return candidateRelations(templateNodeId, maps.nodeMap, maps.relationMap);
}
